import { render } from "./StoryEditor.vue?vue&type=template&id=10976fde"
import script from "./StoryEditor.vue?vue&type=script&lang=js"
export * from "./StoryEditor.vue?vue&type=script&lang=js"

import "./StoryEditor.vue?vue&type=style&index=0&id=10976fde&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__